import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { MktDynamicOfferService } from 'src/app/core/services/mkt-dynamic-offer.service';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { PowerReviewService } from 'src/app/common/services';
import { MktCommonModule } from 'src/app/common/mkt-common.module';
@Component({
  selector: 'app-review-section',
  templateUrl: './review-section.component.html',
  styleUrls: ['./review-section.component.scss'],
  standalone: true,
  imports: [MktCommonModule]
})
export class ReviewSectionComponent implements OnInit, OnDestroy {

  prodName: string;
  cardDetails: any = null;
  reviewContent: any = null;
  reviewContentDisclaimer: any = null;
  cardApplyNowBtnLink: string;
  routeSub: Subscription = new Subscription();
  private dynamicOfferSub: Subscription = new Subscription();
  flowId: string = '';
  hrefTarget: string = '_blank';
  reviews : any = [];
  @Output() applyNowClicked = new EventEmitter<any>();
  constructor(
    private _mktContentStorageService: MktContentStorageService,
    private mktDynamicOfferService: MktDynamicOfferService,
    private powerReview:PowerReviewService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.powerReview.size = window.innerWidth < 768 ? 2 : 3;
    this.getReviewContent();
    //get the dynamic url once the contet is load
    this.dynamicOfferSub = this.mktDynamicOfferService.getApplyNowContent().subscribe((content) => {
      this.cardApplyNowBtnLink = content.applyNowUrl;
    });

  }

  ngOnDestroy() {
    this.dynamicOfferSub.unsubscribe();
    this.routeSub.unsubscribe();
    this.powerReview.size =10;
  }

  private getReviewContent() {
    this.routeSub = combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe(params => {
      const cardName = params[0]['cardName'].replace(/\./g, '');
      this.flowId = params[1]['flowId'] || '';

      // Try to get card pricing details
      const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', cardName, undefined);
      if (mainPdpContentObject) {
        this.cardDetails = JSON.parse(mainPdpContentObject['TEXT']);
        this.reviewContent = JSON.parse(mainPdpContentObject['reviewSection']);
        if (!this.reviewContent || !this.reviewContent.reviewActive) { return; }
      }
    });
  }

  applyNow(value){
    this.applyNowClicked.emit(value);
  }

}



